// extracted by mini-css-extract-plugin
export default {"cls1":"CollapsedActivityPreview-cls1__If","cls2":"CollapsedActivityPreview-cls2_v9u CollapsedActivityPreview-cls1__If"};